import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateDirective } from '../shared/translate.directive';
import { CommonModule } from '@angular/common';
import { LoginService } from '../shared/services/login.service';

@Component({
  selector: 'app-success-payment',
  standalone: true,
  imports: [TranslateDirective, CommonModule],
  templateUrl: './success-payment.component.html',
  styleUrl: './success-payment.component.less'
})
export class SuccessPaymentComponent {
  isLogged: boolean;
  constructor(private router: Router, private loginService: LoginService) {
    this.loginService.contextChange.subscribe(() => {
      this.isLogged = this.loginService.isAuthenticated();
    });
    this.isLogged = this.loginService.isAuthenticated();
  }

  goToDashboard() {
    this.router.navigate(['/app-list']);
  }
}
